import React from 'react';
import {useIntl} from 'react-intl';
import {StudioTab, StudioTabs} from '../../base-components/StudioTab';
import {DataSplitType} from '../../types/dataset/Dataset';

type SplitTab = {
  value: DataSplitType;
  label: string;
  count?: number;
  countLabel: string;
  percentageLabel: string;
};

export const SplitNav = ({
  value,
  totalImages = 0,
  trainDistribution = 0,
  validationDistribution = 0,
  testingDistribution = 0,

  onChange = () => {},
}: {
  value: DataSplitType;
  totalImages: number;
  trainDistribution: number;
  validationDistribution: number;
  testingDistribution: number;
  onChange?(val: DataSplitType): void;
}) => {
  const intl = useIntl();

  const formatTab = ({
    selectedValue,
    tabLabel,
    imagesCount = 0,
    distribution = 0,
  }: {
    selectedValue: DataSplitType;
    tabLabel: string;
    distribution?: number;
    imagesCount?: number;
  }) => ({
    value: selectedValue,
    label: intl.formatMessage({id: tabLabel}),
    count: imagesCount,
    countLabel: intl.formatMessage(
      {id: 'dataViewer.tabCount'},
      {
        distributionCount: imagesCount || 0,
        totalCount: totalImages,
      }
    ),
    percentageLabel: intl.formatMessage(
      {id: 'dataViewer.tabPercentage'},
      {
        percentage: intl.formatNumber(imagesCount / totalImages, {
          style: 'percent',
          maximumFractionDigits: 0,
        }),
      }
    ),
  });

  const SPLIT_TABS: SplitTab[] = [
    formatTab({
      selectedValue: 'TRAIN',
      tabLabel: 'dataViewer.trainingTab',
      imagesCount: trainDistribution,
    }),
    formatTab({
      selectedValue: 'VALIDATION',
      tabLabel: 'dataViewer.validationTab',
      imagesCount: validationDistribution,
    }),
    formatTab({
      selectedValue: 'TEST',
      tabLabel: 'dataViewer.testingTab',
      imagesCount: testingDistribution,
    }),
  ];

  return (
    <div className="data-viewer2__tabs">
      <StudioTabs
        value={value}
        onChange={(_event, index) => onChange(index)}
        className="dashboard__tabs"
        variant="scrollable"
        scrollButtons="auto"
      >
        {SPLIT_TABS.map(splitTab => (
          <StudioTab
            className="data-viewer2__tab"
            key={splitTab.label}
            label={
              <span className="data-viewer2__tab-content">
                <span className="data-viewer2__tab-title">{splitTab.label}</span>
                <span className="data-viewer2__tab-stats">
                  <span>{splitTab.countLabel}</span>
                  <span>{splitTab.percentageLabel}</span>
                </span>
              </span>
            }
            value={splitTab.value}
          />
        ))}
      </StudioTabs>
    </div>
  );
};
